import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DateTime } from 'luxon';
import React from 'react';
import { useNavigate } from '../ProtectedRoute';
import { Notification } from '../Types/Notification';
import { formatDateTime } from '../Utils/Time';

interface NotificationPopupProps {
  notification: Notification;
  onClose: () => void;
  onMarkAsRead: (id: string) => Promise<void>;
}

const NotificationPopup: React.FC<NotificationPopupProps> = ({
  notification,
  onClose,
  onMarkAsRead,
}) => {
  const navigate = useNavigate();

  const handleClick = async () => {
    await onMarkAsRead(notification.id);
    onClose();

    if (notification.link) {
      navigate(notification.link);
    }
  };

  return (
    <div
      className="fixed top-14 right-20 z-50 w-72 
        max-lg:right-12
    "
    >
      {/* Clean notification with triangle pointer */}
      <div className="bg-white rounded-md shadow-lg relative">
        {/* Triangle pointer */}
        <div
          className="absolute -top-2 right-8 w-0 h-0
          max-lg:right-6
          "
          style={{
            borderLeft: '10px solid transparent',
            borderRight: '10px solid transparent',
            borderBottom: '10px solid white',
          }}
        />

        <div
          className="p-4 cursor-pointer hover:bg-gray-50 pr-10"
          onClick={handleClick}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>

          <div className="flex justify-between items-center text-xs text-gray-500 mb-2">
            <span>
              {formatDateTime(DateTime.fromJSDate(notification.createdAt))}
            </span>
            {notification.link && (
              <span className="text-blue-600 font-medium">Click to view</span>
            )}
          </div>
          <p className="text-gray-800 font-bold text-sm mb-0 text-left">
            {notification.message}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;
